import { createContext } from "react";

export const ChargeContinuationContext = createContext([]);